/**
* functions common array
*
* @category   Javascript
* @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
* @copyright  2025 Jakob Ohlsen
*/
export function resizeArray(arr, newSize, value = null) {
    if (newSize < 0) {
        throw new Error("New size must be non-negative");
    }
    const currentSize = arr.length;
    // Always return a fresh array — the grow / shrink branches both return
    // fresh arrays, so the equal-size branch must too. Returning `arr`
    // itself here would create asymmetric aliasing.
    if (newSize === currentSize) {
        return arr.slice();
    }
    if (newSize < currentSize) {
        return arr.slice(0, newSize); // Resize by truncating the array
    }
    const newArray = Array(newSize - currentSize).fill(value);
    return arr.concat(newArray);
}
